import type { UseMutationResult } from '@tanstack/react-query';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { AxiosError } from 'axios';
import { useTranslation } from 'react-i18next';
import { showErrorToast, showSuccessToast } from '../../../utils/toastUtils';
import { useClient } from '../../client-api';
import { type AdvisoryNeedTaskCreateDto, type AdvisoryNeedTaskDto, createAdvisoryNeedTask } from '../../generated/client';
import { queryKeys } from '../../query-keys';

export const useCreateAdvisoryNeedTask = (): UseMutationResult<AdvisoryNeedTaskDto, AxiosError, AdvisoryNeedTaskCreateDto> => {
    const { t } = useTranslation();

    const queryClient = useQueryClient();
    const { data: client } = useClient();

    return useMutation({
        mutationFn: (task) => createAdvisoryNeedTask({ body: task }).then((result) => result.data!),
        onSuccess: () => {
            showSuccessToast(t('needAddedToRoadmap'));
            queryClient.invalidateQueries({ queryKey: queryKeys.advisoryNeedTasks(client?.partnerUuid) });
            queryClient.invalidateQueries({ queryKey: queryKeys.events(client?.partnerUuid) });
            queryClient.invalidateQueries({ queryKey: queryKeys.notifications() });
            queryClient.invalidateQueries({ queryKey: queryKeys.notificationsForClient(client?.id) });
        },
        onError: (error) => showErrorToast({ error, userMessage: t('pleaseTryAgainCouldNotAddNeedToRoadmap') }),
    });
};
